import {OptionType} from 'platform/components';

import {GetServiceOrderVariantPaymentTypeApiResponse} from '@dms/api/workshop';
import i18n from '@dms/i18n';

import {buildArray} from 'shared/web';

export const getOrderPaymentOptions = (
  orderVariantPayment?: GetServiceOrderVariantPaymentTypeApiResponse
) =>
  buildArray<OptionType>()
    .when(orderVariantPayment?.bankPayment?.isAllowed ?? true, {
      label: i18n.t('entity.invoice.paymentMethod.bankTransfer'),
      value: 'BANK_TRANSFER',
    })
    .when(orderVariantPayment?.cardPayment?.isAllowed ?? true, {
      label: i18n.t('entity.invoice.paymentMethod.card'),
      value: 'CARD',
    })
    .when(orderVariantPayment?.cashPayment?.isAllowed ?? true, {
      label: i18n.t('entity.invoice.paymentMethod.cash'),
      value: 'CASH',
    })
    .when(orderVariantPayment?.internalPayment?.isAllowed ?? true, {
      label: i18n.t('general.labels.internal'),
      value: 'INTERNAL',
    });
